import { createAsyncThunk } from "@reduxjs/toolkit";
import { getHeaders, 
  getCourseSessions,
  cancelCourseSession,
  addCourseSessions as postCourseSessions,
  updateCourseSessions as putCourseSessions,
  deleteCourseSessions as removeCourseSessions,
  addAssignmentQuestions as postAssignmentQuestions,
  deleteAssignmentQuestions as removeAssignmentQuestions,
  addAdditionalAssignmentQuestions,
  deleteAdditionalAssignmentQuestions as removeAdditionalAssignmentQuestionsBackend // Import and alias
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Table Column Names
export const fetchCourseSessionsTableColumnNames = createAsyncThunk("sessions/fetchTableColumnNames", async (module, thunkAPI) => {
    try {
      const response = await getHeaders(module); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

//Screens manage

export const fetchQuestionsTableColumnNames = createAsyncThunk(
  "sessions/fetchQuestionsTableColumnNames",
  async (module, thunkAPI) => {
    try {
      const response = await getHeaders(module);      
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Fetch All Courses Sessions
export const fetchAllCourseSessions = createAsyncThunk("sessions/fetchAll", async (module, thunkAPI) => {
    try {
      const response = await getCourseSessions(module); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Add Course Sessions
export const createCourseSessions = createAsyncThunk("sessions/add", async (module, thunkAPI) => {  
    try {
        const response = await postCourseSessions(module);
        toast.success(t(response.message));
        return response;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Update Course Sessions
export const updateCourseSessions = createAsyncThunk("sessions/update", async (module, thunkAPI) => {
    try {
        const response = await putCourseSessions(module);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Delete Course Sessions
export const deleteCourseSessions = createAsyncThunk("sessions/delete", async (module, thunkAPI) => {
    try {
        const response = await removeCourseSessions(module);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message)
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// cancel Course Sessions
export const cancelCourseSessions = createAsyncThunk("sessions/cancel", async (module, thunkAPI) => {
    try {
        const response = await cancelCourseSession(module);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message)
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Add Assignment Question
export const createAssignmentQuestions = createAsyncThunk("sessions/addAssignment", async (module, thunkAPI) => {  
    try {
        const response = await postAssignmentQuestions(module);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Remove Assignment Question
export const deleteAssignmentQuestions = createAsyncThunk("sessions/deleteAssignment", async (module, thunkAPI) => {  
    try {
        const response = await removeAssignmentQuestions(module);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Add Assignment Question
export const createAdditionalAssignmentQuestions = createAsyncThunk("sessions/createAdditionalAssignmentQuestions", async (module, thunkAPI) => {  
    try {
        const response = await addAdditionalAssignmentQuestions(module);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Remove Assignment Question
export const deleteAdditionalAssignmentQuestions = createAsyncThunk("sessions/deleteAdditionalAssignmentQuestions", async (module, thunkAPI) => {  
    try {
        const response = await removeAdditionalAssignmentQuestionsBackend(module); // Use the aliased backend helper
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});